
import { useParsedFieldProps } from "./useParsedFieldProps";
import { BOOLEAN } from "../SchemaTypes";
import Field from "../Field";
import CheckBoxInput from "../../Input/CheckBoxInput";

const CheckBoxField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent, label, defaultChecked } = props;

  const schema = {
    type: BOOLEAN,
    parent,
    validations: {
      required
    }
  };

  return (
    <Field {...fieldProps} schema={schema} label={false}>
      <CheckBoxInput {...inputProps} label={label} checked={defaultChecked} />
    </Field>
  );
};

export default CheckBoxField;
